import { Link } from 'react-router-dom';

/**
 * How many rows any one digest section renders before it defers to the full surface
 * (Dan, 2026-08-18: "limit the number of items shown to 5, so the list part doesn't go
 * crazy when we do a bunch of shopping").
 *
 * The cap is a **view** concern and lives only here. `composeDigest` deliberately keeps
 * returning everything, because its counts are also what the morning push says out loud —
 * a digest that pushed "3 new items" because the view stops at five, when eleven were
 * added, would be lying to get a tidier screen. The section header keeps the honest total;
 * only the rows are trimmed.
 */
export const DIGEST_SECTION_CAP = 5;

/**
 * The overflow affordance: "+12 more →", linking to wherever the rest actually lives.
 * Renders nothing when nothing was hidden, so a section under the cap has no dangling
 * furniture beneath it.
 */
export function MoreLink({
  hidden,
  to,
  label = 'more',
  testId,
}: {
  hidden: number;
  to: string;
  /** Overrides the noun when "more" alone would be ambiguous. */
  label?: string;
  testId?: string;
}): JSX.Element | null {
  if (hidden <= 0) return null;
  return (
    <Link
      to={to}
      data-testid={testId ?? 'digest-more-link'}
      className="-mx-1.5 flex min-h-9 items-center rounded-sm px-1.5 text-xs font-semibold text-accent transition-colors hover:bg-raised"
    >
      +{hidden} {label} →
    </Link>
  );
}
